export default __webpack_public_path__ + "static/media/character-left.8a6fa592.png";